import axios from 'axios'
export const $getJson = function (url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      dateType: 'json',
      crossDomain: true,
      cache: false
    }).then(
      res => {
        resolve(res)
      }).catch(
      error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/json/http.js